import React from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import {
  Box,
  Image,
  DesktopOnly,
  Responsive,
  componentHeights as heights
} from 'ui/acro'

const ImageBox = styled(Box)`
  /* Hide image on tiny screens to prevent modal content from overflowing */
  ${(props) => props.theme.mediaQueries.tiny} {
    display: none;
  }
`

const StyledImage = styled(Image)(
  {
    objectFit: 'cover',
    width: '100%'
  },
  css({
    height: [null, null, '100%']
  })
)

const ModalImage = () => {
  return (
    <ImageBox width={['100%', null, '50%']}>
      <Responsive show={[true, true, false]}>
        <StyledImage
          src={
            'https://d28gwrkukqy4h7.cloudfront.net/rebrand/rebrandMobile.png'
          }
        />
      </Responsive>

      <DesktopOnly>
        <StyledImage
          src={'https://d28gwrkukqy4h7.cloudfront.net/rebrand/rebrand.jpg'}
          maxHeight={heights.modalMax.desktop}
        />
      </DesktopOnly>
    </ImageBox>
  )
}

export default ModalImage
